import * as React from "react";
import { TextInput, View, TouchableOpacity, StyleSheet } from "react-native";
import { Header, Left, Body, Right, Button } from "native-base";

import Icon from "react-native-vector-icons/FontAwesome";

import SearchComponent from "@components/SearchComponent";
import EntriesComponent from "@components/EntriesComponent";
import BarcodeInput from "@components/BarcodeInputComponent";

export default class SalesList extends React.PureComponent {
  onPressItem = index => this.props.onItemClick(index);
  onItemEndReached = () => this.props.onEndReached("item");

  ref = c => {
    this.barcode = c;
  };

  onFocusInput() {
    this.barcode.focus();
  }

  renderSearch() {
    const { onSearchClick, onChangeSalesSearchText } = this.props;
    return (
      <SearchComponent
        status="Sales"
        onSearchClick={onSearchClick}
        onChangeText={onChangeSalesSearchText}
      />
    );
  }

  renderHeader() {
    return (
      <Header>
        <Left>
          <Button transparent>
            <Icon
              active
              name="menu"
              onPress={() => this.props.navigation.navigate("DrawerOpen")}
              size={24}
              color="white"
            />
          </Button>
        </Left>
        <Body />
        <Right>
          <TouchableOpacity onPress={this.onSearchClick}>
            <Icon
              size={25}
              name="search"
              color="white"
              style={styles.headerRightIcon}
            />
          </TouchableOpacity>
        </Right>
      </Header>
    );
  }

  renderBarcode() {
    const { onCloseClick, onBarcodeRead } = this.props;
    return (
      <BarcodeInput
        status="Sales"
        onBarcodeRead={onBarcodeRead}
        onChangeSalesStatus={onCloseClick}
      />
    );
  }

  render() {
    const {
      salesListStatus,
      bluetoothStatus,

      // EntriesComponent
      currency,
      itemData,
      itemsLength,
      onLongPressItem,

      // TextInput
      onChangeBarcodeScannerInput,

      // Descriptive items
      useDescription,
      listStatus,
      isCurrencyDisabled,
      company,
    } = this.props;

    return (
      <View style={styles.container}>
        {salesListStatus ? (
          this.renderBarcode()
        ) : (
          <View style={styles.container}>
            <EntriesComponent
              company={company}
              listStatus={listStatus}
              isCurrencyDisabled={isCurrencyDisabled}
              data={itemData}
              currency={currency}
              itemsLength={itemsLength}
              onPressItem={this.onPressItem}
              onLongPressItem={onLongPressItem}
              onEndReached={this.onItemEndReached}
              useDescription={useDescription}
            />
            {bluetoothStatus ? (
              <View style={styles.footerView}>
                <TextInput
                  ref={this.ref}
                  autoFocus={true}
                  style={styles.footerBarcode}
                  placeholder="Scan a barcode"
                  underlineColorAndroid="transparent"
                  value={this.props.barcodeScannerInput}
                  onChangeText={onChangeBarcodeScannerInput}
                  onSubmitEditing={() => {
                    this.props.onBluetoothScan(this.props.barcodeScannerInput);
                    this.onFocusInput();
                  }}
                  blurOnSubmit={false}
                />
              </View>
            ) : null}
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  headerRightIcon: {
    paddingRight: 5,
  },
  footerView: {
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  footerBarcode: {
    height: 44,
    paddingHorizontal: 14,
    borderWidth: 1,
    borderColor: "#d5dbe5",
    borderRadius: 10,
    backgroundColor: "#fff",
    fontSize: 15,
  },
});
